import { SimpleForm } from 'react-admin';
import FormContent from './FormContent';
import { CreateStyled } from '@/styles/overrides';
import { OverrideLogicFormProps } from './types';

const OverrideLogicForm = ({ onClose, selectedIds, ...props }: OverrideLogicFormProps) => {
  return (
    <CreateStyled title="Override" {...props}>
      <SimpleForm mode="onChange" reValidateMode="onChange" toolbar={false}>
        <FormContent onClose={onClose} selectedIds={selectedIds} />
      </SimpleForm>
    </CreateStyled>
  );
};

export default OverrideLogicForm;
